import { toast } from 'react-toastify';

export const success = (str: string, opt = {}) => {
  toast.success(str, opt);
};

export const error = (str: string, opt = {}) => {
  toast.error(str, opt);
};

export const info = (str: string, opt = {}) => {
  toast.info(str, opt);
};

export const remove = () => {
  toast.dismiss();
};

export const snackbar = { remove, success, error, info };
